import { makeStyles } from '@material-ui/core/styles'
import { specialThemePdf, widthSM, widthXS } from '../theme'

export const useStylesPdf = makeStyles((theme) => ({
  centerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  centerRowOverview: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  fieldSize: {
    fontFamily: specialThemePdf.font.fontFSMe,
    width: '100%',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'row',
    padding: specialThemePdf.layout.gridItemPadding,
    [theme.breakpoints.down(widthXS)]: {
      padding: specialThemePdf.layout.gridItemPaddingDownWidthXS,
    },
  },
  gridOverview: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: specialThemePdf.font.fontFSMe,
    padding: specialThemePdf.layout.gridOverviewPadding,
    [theme.breakpoints.down(widthXS)]: {
      padding: specialThemePdf.layout.gridOverviewPaddingDownWidthXS,
    },
  },
  overviewContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    border: `3px solid ${specialThemePdf.colors.gray.warmGray}`,
    backgroundColor: specialThemePdf.colors.white,
    maxWidth: specialThemePdf.layout.gridMainFormMaxWidth,
    padding: '0 1.2rem 1.2rem 1.2rem',
    marginTop: '1.2rem',
    [theme.breakpoints.down(widthSM)]: {
      padding: '0 1.2rem 1.2rem 1.2rem',
    },
  },
  overviewLabel: {
    color: specialThemePdf.colors.dark,
    fontFamily: specialThemePdf.font.fontFSMe,
    fontWeight: 500,
    letterSpacing: specialThemePdf.layout.gridTypographyTextLetterSpacing,
    margin: specialThemePdf.layout.gridTypographyOverviewMargin,
  },
  paragraphText: {
    color: specialThemePdf.colors.dark,
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontWeight: 600,
    fontFamily: specialThemePdf.font.fontFSMe,
    letterSpacing: 0.24,
    margin: '1.2rem 0 0 0',
  },
  pdf: {
    fontFamily: 'fs me web',
    fontSize: '12px',
    width: 700,
    // Explicitní barva textu pro celý PDF. Bez ní text bez vlastního `color`
    // dědí výchozí systémovou barvu, kterou html2canvas v některých prostředích
    // (např. tmavý režim / vysoký kontrast) vyhodnotí jako bílou → bílý text na
    // bílém pozadí = neviditelný obsah. Viz DEV-8724.
    color: specialThemePdf.colors.dark,
  },
  text: {
    color: specialThemePdf.colors.darkRed,
    fontFamily: specialThemePdf.font.fontFSMe,
    fontSize: '1.3rem',
    fontWeight: specialThemePdf.layout.gridTypographyTextFontWeight,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: specialThemePdf.layout.gridTypographyTextFontSizeWidthXS,
    },
    letterSpacing: specialThemePdf.layout.gridTypographyTextLetterSpacing,
    margin: specialThemePdf.layout.gridTypographyTextMargin,
  },
  textOverview: {
    color: specialThemePdf.colors.darkRed,
    fontFamily: specialThemePdf.font.fontFSMe,
    fontSize: '1.3rem',
    fontWeight: specialThemePdf.layout.gridTypographyTextFontWeight,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: specialThemePdf.layout.gridTypographyTextFontSizeWidthXS,
    },
    letterSpacing: specialThemePdf.layout.gridTypographyTextLetterSpacing,
    margin: specialThemePdf.layout.gridTypographyTextMargin,
  },
}))
